"use strict";
// ================================================================
// v2/theme/useV2Palette.ts
// v2 コンポーネントから theme.palette.v2 を型安全に取得するフック。
// テーマに v2 が注入されていない場合 (古いテーマ等) は mode から生成して
// フォールバックするため、コンポーネント側は undefined を気にしなくてよい。
//
// あわせて theme.palette.primary (アプリ毎の theme.json 由来) を
// primary 系トークンに反映する。palette.v2 自体は theme.json の
// deepmerge 対象外なので、唯一のアクセサであるこのフックで合成する。
// これにより AppThemeProvider / ArtistThemeProvider / Storybook の
// どの経路でテーマが作られてもアプリ色が反映される。
// ================================================================
Object.defineProperty(exports, "__esModule", { value: true });
exports.useV2Palette = useV2Palette;
var material_1 = require("@mui/material");
var react_1 = require("react");
var createV2Palette_1 = require("./createV2Palette");
/**
 * テーマ単位の合成結果キャッシュ。
 *
 * このフックは v2 部品ごとに呼ばれるため (カード1枚で TicketCard / GlassCard /
 * MembershipBadge / Badge …)、useMemo だけだとコンポーネントの数だけ同じ内容の
 * パレットが複製される。theme.palette は ThemeProvider 配下で同一参照なので、
 * それをキーにして合成を1回に抑える。
 * テーマが作り直されれば別オブジェクトになるので、古い値は返らない。
 */
var paletteCache = new WeakMap();
function useV2Palette() {
    var theme = (0, material_1.useTheme)();
    var _a = theme.palette, v2 = _a.v2, mode = _a.mode, primary = _a.primary, secondary = _a.secondary, info = _a.info, warning = _a.warning, error = _a.error, grey = _a.grey, text = _a.text, custom = _a.custom;
    var palette = theme.palette;
    var onPrimary = custom === null || custom === void 0 ? void 0 : custom.onPrimary;
    return (0, react_1.useMemo)(function () {
        var cached = paletteCache.get(palette);
        if (cached)
            return cached;
        var themeMode = mode === 'dark' ? 'dark' : 'light';
        var base = v2 !== null && v2 !== void 0 ? v2 : (0, createV2Palette_1.createV2Palette)(themeMode);
        var withBrand = (0, createV2Palette_1.withV2BrandColors)(base, primary, { secondary: secondary, info: info, warning: warning, error: error }, onPrimary, themeMode);
        var merged = (0, createV2Palette_1.withV2NeutralColors)(withBrand, grey, text);
        paletteCache.set(palette, merged);
        return merged;
    }, [
        palette,
        v2,
        mode,
        primary,
        secondary,
        info,
        warning,
        error,
        grey,
        text,
        onPrimary,
    ]);
}
